import axiosInstance from "./api_helper";

const stockService = {
    search: async ({ query = '', page = 0, size = 10, productId = null }) => {
        const params = { query, page, size };
        if (productId) {
            params.productId = productId;
        }
        return axiosInstance.get('/api/stocks/search', { params });
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/stocks/${id}`);
    },
    save: async (stock) => {
        return axiosInstance.post(`/api/stocks`, JSON.stringify(stock));
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/stock`, JSON.stringify(payload));
    },
    transferStock: async (data) => {
        return axiosInstance.post(`/api/stock/transfer`, JSON.stringify(data));
    },
    adjustStock: async (payload) => {
        return axiosInstance.post(`/api/articles/stock-adjustments`, JSON.stringify(payload));
    },
    listStocks: async ({ entrepotId }) => {
        const params = { entrepotId };
        return axiosInstance.get(`/api/entrepots/stocks`, { params });
    },
    upload: async (payload) => {

        return axiosInstance.post(`/api/entrepots/upload`, payload.formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    getMouvements: async ({ entrepotId = null, dateFrom = null, dateTo = null, query = null }) => {
        const params = {};

        if (entrepotId) params.entrepotId = entrepotId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;

        return axiosInstance.get(`/api/stock/mouvements`, { params });
    }


};
export default stockService;
